export const getReactAppEnv = () => process.env.REACT_APP_ENV || 'staging';

export const isProductionEnv = () => getReactAppEnv() === 'production';

export const isNonProductionEnv = () => !isProductionEnv();

export default function getEnv() {
  return isProductionEnv() ? 'production' : 'development';
}
